import React, { useEffect, useState } from "react";

const DropdownSection = ({ defaultOpen, children, label}) => {
  const [open, setOpen] = useState(defaultOpen || false)


  return (
    <div 
      className={`catalog-items-form-dropdown-section ${open ? "open" : "closed"}`}
    >
      <div className="catalog-items-form-dropdown-section-header" onClick={() => setOpen(!open)}>
        <img src="/images/icons/ChevronRight.svg" className="catalog-items-form-dropdown-section-header-chevron"/>
        {label}
      </div>
      <div className="catalog-items-form-dropdown-section-content">
        {children}
      </div>
    </div>
  )

  
}

export default DropdownSection